import { FiLogOut, FiSettings } from 'react-icons/fi';
import {
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
} from '@/ui/design-system/components/ui/sidebar';
import Link from '../Link';
import { useFetchUserAbout } from 'utils/hooks';
import { useSelector } from 'react-redux';

function SidebarUserFooter() {
    const aboutQuery = useFetchUserAbout();
    const { firstname, lastname } = aboutQuery.data?.profile || {};
    const { user_email } = useSelector(({ session }) => session);

    const userName =
        firstname && lastname ? `${firstname} ${lastname}` : firstname || null;

    const userEmail = user_email || null;

    if (!userName && !userEmail) return null;

    const createLogOutAriaLabel = () => {
        let label = 'Log out.';
        if (!(userName || userEmail)) return label;
        label += ' Currently logged in ';
        if (userName) label += ` as ${userName}`;
        if (userEmail) label += ` with e-mail ${userEmail}`;
        return `${label}.`;
    };

    return (
        <SidebarMenu>
            <SidebarMenuItem>
                <SidebarMenuButton asChild tooltip="Settings">
                    <Link to="/settings" mixpanelContext="User Settings">
                        <FiSettings />
                        <span>Settings</span>
                    </Link>
                </SidebarMenuButton>
            </SidebarMenuItem>
            <SidebarMenuItem>
                <SidebarMenuButton asChild tooltip="Log out" className="h-auto">
                    <Link
                        to="/logout"
                        aria-label={createLogOutAriaLabel()}
                        mixpanelContext="User Logout"
                    >
                        <FiLogOut className="scale-x-[-1]" />
                        <div className="flex flex-col gap-0.5 leading-tight">
                            <span
                                className="truncate text-sm font-medium"
                                {...(userName && { id: 'user_fullname' })}
                            >
                                {userName || 'Log Out'}
                            </span>
                            {userEmail && (
                                <span
                                    className="truncate text-xs text-muted-foreground lowercase"
                                    id="user_email"
                                >
                                    {userEmail}
                                </span>
                            )}
                        </div>
                    </Link>
                </SidebarMenuButton>
            </SidebarMenuItem>
        </SidebarMenu>
    );
}

export default SidebarUserFooter;
